var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocksImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 198,
    viewBox: "0 0 150 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 48H0V138H90V48Z",
    fill: "#05F59B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138 0H90V48H138V0Z",
    fill: "#2828F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 138H90V198H150V138Z",
    fill: "#6030F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksImg);
export default __webpack_public_path__ + "static/media/BlocksImg.b3a569ec10af3cf42fc71e41b82324b4.svg";
export { ForwardRef as ReactComponent };